const scrollToTop = () => {
  window.scrollTo(0, 0) // eslint-disable-line
}

const goToErrorPage = errorCode => {
  let errorUrl = 'https://oops.olx.com.br/502.html'
  if (errorCode) errorUrl += `?error=${errorCode}`
  window.location = errorUrl
}

export default { scrollToTop, goToErrorPage }
